<template>
  <div class="scroll-to-the-top"
       ref="scrollToTopButton"
       @click="scrollToTop">
    <img src="~@/assets/back-to-the-top-arrow.svg"
         alt="back to the top arrow">
  </div>
</template>

<script>
export default {
  name: 'backToTheTop',
  methods: {
    scrollToTop () {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    },
    fadeInScrollToTop () {
      if (window.pageYOffset > 900) {
        this.$refs.scrollToTopButton.classList.add('is--visible')
      } else {
        this.$refs.scrollToTopButton.classList.remove('is--visible')
      }
    },
  },
  created () {
    window.addEventListener('scroll', this.fadeInScrollToTop)
  },
  destroyed () {
    window.removeEventListener('scroll', this.fadeInScrollToTop)
  },
}
</script>

<style scoped lang="scss">
  .scroll-to-the-top {
    align-items: center;
    background-color: $brand-primary;
    cursor: pointer;
    display: flex;
    height: 50px;
    justify-content: center;
    opacity: 0;
    position: fixed;
    right: 30px;
    top: 400px;
    transform: translateY(0);
    transition: all 300ms ease-in-out;
    width: 50px;
    z-index: 10;

    &:hover {
      transform: translateY(-5px);
    }

    &.is--visible {
      opacity: 1;
    }

    > img {
      @include size(22px);
    }
  }
</style>
